import { getMedias } from "@omni/mappers/product/shared/media.mapper";
import { Divider } from "@omni/ui/components/Divider/divider.component";
import * as CartUtils from "@omni/utils/cart.utils";
import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { CTAListRenditions } from "@/components/Product/ProductImage/mappedRenditions";
import { ProductImageContainer } from "@/components/Product/ProductImage/productImage.container";
import {
    CTAActions,
    ProductCallToAction
} from "@/redux/modules/api/data/cart/@types/cart.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";

type Props = {
    cta: ProductCallToAction;
    activatedAction?: CTAActions;
};

const List = ({ cta, activatedAction }: Props) => {
    const { t } = useGranite();
    const { messages } = useCallToActionsContext();
    const product = cta.product;

    return (
        <>
            {product && (
                <>
                    <Divider className={cn("mb-3")} />
                    <Row>
                        <Col xs={"auto"}>
                            <ProductImageContainer
                                title={CartUtils.getTitle(product, t)}
                                medias={getMedias(
                                    product.warrantyDeposit,
                                    CartUtils.getTitle(product, t),
                                    product.product?.mainImages,
                                    product.articleConfiguration
                                )}
                                isEcoChequesAccepted={false}
                                className={cn("tw:w-16!")}
                                renditions={CTAListRenditions}
                            />
                        </Col>
                        <Col
                            xs={8}
                            className="d-flex align-items-center"
                        >
                            <p className="m-0">
                                {CartUtils.getTitle(product, t)}
                            </p>
                        </Col>
                    </Row>
                    <Divider />
                </>
            )}
            {messages.map((m) => (
                <p key={m.key}>{m.message}</p>
            ))}
            {cta.actions.length > 1 &&
                cta.actions.map((a) => a.visual?.(cta.product, a))}
            {!activatedAction?.isExtended &&
                activatedAction?.action &&
                activatedAction?.action(cta.product, activatedAction)}
        </>
    );
};

export default List;
